import styled from '@emotion/styled';
import {colors, sizes} from 'patient-ping-remedy/packages/theme';
import Input from 'patient-ping-remedy/packages/input';

export const Content = styled.div<{ isScrollable?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${sizes.medium};

  height: ${({ isScrollable }) => isScrollable ? '100%' : 'auto'};
  overflow-y: ${({ isScrollable }) => isScrollable ? 'auto' : 'visible'};
`;

export const SubjectContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${sizes.small};
`;

export const SubjectLabel = styled.div`
  display: flex;
  align-items: center;
  gap: ${sizes.xxSmall};
`;

export const Subject = styled(Input)`
  flex-basis: 100%;

  & > input[type="text"] {
    border: 1px solid ${colors.gray3};
    border-radius: 8px;

    &::placeholder {
      color: ${colors.gray3};
    }
  }

  & > span {
    display: none;
  }
`;

export const Details = styled.div`
  display: flex;
  justify-content: end;
  flex: 1;
`;
